import { useState } from 'react';
import AddPatient from './AddPatientComponent';
import AddPracticeForm from './AddPracticeComponent';
import register_help_icon from './register_help_icon.svg';

function SignupForm({ defaultTab = null }) {
  const [activeTab, setActiveTab] = useState(defaultTab);
  const [formKey, setFormKey] = useState(0); // Force re-render when tab changes

  const handleTabChange = (tab) => {
    setActiveTab(tab);
    setFormKey(prev => prev + 1); // Increment key to force form re-render
  };

  return (
    <div className="w-full max-w-7xl mx-auto p-4 sm:p-6 lg:p-8">
      <div className="flex justify-center mb-4 sm:mb-6">
        <div className="bg-gray-100 border border-gray-300 rounded-md p-1 w-full max-w-2xl h-12 sm:h-14 flex">
          <button
            onClick={() => handleTabChange('patient')}
            className={`flex-1 py-2 px-4 rounded text-sm sm:text-base font-medium transition-colors ${activeTab === 'patient'
                ? 'bg-teal-600 text-white'
                : 'text-gray-700 hover:bg-gray-200'
              }`}
          >
            Patient
          </button>
          <button
            onClick={() => handleTabChange('practice')}
            className={`flex-1 py-2 px-4 rounded text-sm sm:text-base font-medium transition-colors ${activeTab === 'practice'
                ? 'bg-teal-600 text-white'
                : 'text-gray-700 hover:bg-gray-200'
              }`}
          >
            Practice
          </button>
        </div>
      </div>
      <div className="mt-4 sm:mt-6">
        {!activeTab && (
          <div className="text-center py-12">
            <div className="mb-4">
              <img src={register_help_icon} alt="Register Help" className="w-24 h-24 mx-auto" />
            </div>
            <h3 className="text-lg font-medium text-gray-900 mb-2">Please select your registration type</h3>
            <p className="text-gray-600">Choose whether you want to register as a Patient or Healthcare Practice to continue.</p>
          </div>
        )}
        {activeTab === 'patient' && <div className="addPatient-div"><AddPatient key={formKey} /></div>}
        {activeTab === 'practice' && <div className="addPractice-div"><AddPracticeForm key={formKey} /></div>}
      </div>
    </div>
  );
}

export default SignupForm;
